import { NgModule } from '@angular/core';
import { AddressComponent } from './address.component';
import { AddressDetailsComponent } from './address-details/address-details.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WindowlistModule } from 'projects/core/src/common/windowlist/windowlist.module';
import { CitiesModule } from '../../modules/cities/cities.module';
import { PaginationModule } from 'projects/core/src/common/pagination/pagination.module';
import { AdvancedsearchModule } from '../../modules/advancedsearch/advancedsearch.module';
import { AddressRoutingModule } from './address-routing.module';
import { ContactModule } from '../../modules/contact/contact.module';
import { CashFlowModule } from '../cash-flow/cash-flow.module';
import { ToolbarmodelModule } from 'projects/core/src/common/toolbarmodel/toolbarmodel.module';
import { ShopsModule } from '../shops/shops.module';
import { DocumentsModule } from '../documents/documents.module';
import { ContractsModule } from '../contracts/contracts.module';
import { NoteboxModule } from '../../modules/notebox/notebox.module';
import { WindowModule } from 'projects/core/src/common/window/window.module';
import { DeadlinesModule } from '../deadlines/deadlines.module';
import { NationsModule } from 'projects/core/src/common/nations/nations.module';
import { ActivitiesModule } from '../activities/activities.module';
import { CustomfieldsModule } from 'projects/core/src/common/customfields/customfields.module';
import { TaxCodeModule } from '../../modules/tax-code/tax-code.module';
import { VatNumberModule } from '../../modules/vat-number/vat-number.module';
import { ProductsModule } from '../products/products.module';
import { FilesModule } from '../../modules/files/files.module';
import { Globals } from 'projects/core/src/globals';
import { FinancialaccountModule } from '../../modules/financialaccount/financialaccount.module';
import { WindowlistbuttonsModule } from 'projects/core/src/common/windowlistbuttons/windowlistbuttons.module';
import { NgPipesModule } from 'ngx-pipes';
import { AddressSettingsComponent } from './settings/settings.component';
import { NotificationsModule } from 'projects/core/src/common/notifications/notifications.module';
import { DossierModule } from 'projects/modules/src/app/dossier/dossier.module';
import { ProjectsModule } from '../projects/projects.module';
import { TodoModule } from 'projects/modules/src/app/todo/todo.module';
import { SelectTablesModule } from 'projects/core/src/common/tables/tables.module';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        AddressRoutingModule,
        CustomfieldsModule,
        WindowlistModule,
        WindowModule,
        ToolbarmodelModule,
        PaginationModule,
        CitiesModule,
        AdvancedsearchModule,
        ContactModule,
        NoteboxModule,
        CashFlowModule,
        ShopsModule,
        ProductsModule,
        DocumentsModule,
        ContractsModule,
        ProjectsModule,
        DeadlinesModule,
        ActivitiesModule,
        NationsModule,
        TaxCodeModule,
        VatNumberModule,
        NotificationsModule,
        FilesModule,
        FinancialaccountModule,
        WindowlistbuttonsModule,
        DossierModule,
        NgPipesModule,
        TodoModule,
        SelectTablesModule
    ],
   exports: [AddressComponent,AddressDetailsComponent,AddressSettingsComponent],
   declarations: [AddressComponent,AddressDetailsComponent,AddressSettingsComponent],
   providers: [],
})
export class AddressModule{ 

    constructor(){
        Globals.parameters.loadModulesEvent.subscribe((result)=>{
            Globals.parameters.createParam(
                "address",
                "mode_balance",
                "Modalità calcolo bilancio",
                "select",
                [
                    {"value":0,"label":"Nessun calcolo"},
                    {"value":1,"label":"Calcola il bilancio come differenza tra versato ed importo"},
                    {"value":2,"label":"Calcola il bilancio come somma di tutti i movimenti di entrata ed uscita"}
                ]
            );

            Globals.parameters.createParam(
                "address",
                "id_type_default",
                "Tipologia di default",
                "type",
                [],
                2
            );
       
            Globals.parameters.createParam(
                "address",
                "mode_view",
                "Modalità di visualizzazione predefinita",
                "select",
                [
                    {"value":0,"label":"A card"},
                    {"value":1,"label":"A lista"}
                ]
            );

            Globals.parameters.createParam(
                "address",
                "view_module_linked",
                "Modulo collegato da visualizzare per primo quando si apre un'anagrafica",
                "select",
                [
                    {"value":1,"label":"Movimenti"},
                    {"value":2,"label":"Scadenze"},
                    {"value":3,"label":"Attività"},
                    {"value":4,"label":"Documenti"},
                    {"value":5,"label":"Installazioni"},
                    {"value":6,"label":"Sedi"},
                    {"value":7,"label":"Contratti"},
                    {"value":8,"label":"Notifiche"},
                    {"value":9,"label":"Pratiche"},
                    {"value":10,"label":"Progetti"},
                    {"value":11,"label":"Promemoria"}
                ]
            );

            Globals.permissions.addPermissionRule("address","add","Nuova anagrafica");
            Globals.permissions.addPermissionRule("address","save","Salvataggio");
            Globals.permissions.addPermissionRule("address","delete","Eliminazione");
            Globals.permissions.addPermissionRule("address","export","Esportazioni");
            Globals.permissions.addPermissionRule("address","notify","Notifiche");
            Globals.permissions.addPermissionRule("address","saveListUser","Crea gruppi anagrafiche");
            Globals.permissions.addPermissionRule("address","advancedFilter","Ricerca avanzata");
            Globals.permissions.addPermissionRule("address","other","Altre funzioni");
            Globals.permissions.addPermissionRule("address","showOtherData","Mostra altri dati");
            Globals.permissions.addPermissionRule("address","showNotes","Mostra note");
            Globals.permissions.addPermissionRule("address","showFiles","Mostra file allegati");
            Globals.permissions.addPermissionRule("address","showBalance","Mostra saldi");
            Globals.permissions.addPermissionRule("address","showTypeFilter","Mostra filtro di ricerca per tipologia");
            
            
        });

        

    }
}